import Button from "../../atoms/Button";
import ImageCard from "../../atoms/ImageCard";
import { Link } from "react-router-dom";
const NewsCard = ({
  id,
  newsTitle,
  imgSrc,
  src,
  projectName,
  categoryName,
}) => {
  return (
    <Link to={`/news-description/${id}`}>
      <div className="flex p-2">
        <div className="w-20 h-20 relative bg-newsCardShadow rounded-xl ml-1">
          <ImageCard
            iconDisplay="flex"
            classnames="w-[11rem] h-[6rem] lg:w-[12.625rem] lg:h-[6.625rem] bg-cover m-auto  flex items-center justify-center text-2xl font-bold text-white"
            userImage={src}
          ></ImageCard>
          <img
            className="rounded-xl w-20 h-20 absolute right-1 bottom-1"
            src={imgSrc}
          />
        </div>
        <div className="block ml-4">
          <div className="w-44 mb-2">
            <p className="text-black text-xs text-left font-medium">
              {newsTitle}
            </p>
          </div>
          <Button
            varient="secondary"
            color="blue"
            borderColor="blue"
            className="w-16 h-6"
          >
            <p className="text-white text-[0.5rem] font-bold text-center">
              Read More
            </p>
          </Button>
        </div>
      </div>
    </Link>
  );
};
export default NewsCard;
